/* @flow weak */
import React from 'react';

import Text from 'components/Text.jsx';
import TextEntities from 'lib/TextEntities';
import TextWithEntities from 'components/TextWithEntities.jsx';

const ChatTitle = ({ title, query }) => {
  let text = title;

  if (query !== '') {
    const parser = TextEntities.createTextMatchingParser(query);
    text = <TextWithEntities text={text} entities={parser(text)} />;
  }

  return (
    <Text truncate className="ChatListItem-name">
      {text}
    </Text>
  );
};

ChatTitle.propTypes = {
  title: React.PropTypes.string.isRequired,
  query: React.PropTypes.string,
};

export default ChatTitle;



// WEBPACK FOOTER //
// ./src/chat/components/ChatTitle.jsx